import {ComponentProps} from '@episerver/spa-core/EpiComponent';
import useFadeIn from 'app/Components/Shared/UseFadeIn';
import JoiningItemBlockData from 'Models/Content/JoiningItemBlockData';
import JoiningItemsBlockData from 'Models/Content/JoiningItemsBlockData';
import React from 'react';
import {Container} from 'reactstrap';
import {getBackgroundImageProps} from 'app/utilities/ImageProps';

const JoiningItemsBlock = ({data, context}: ComponentProps<JoiningItemsBlockData>) => {
  const {fadeClass, ref} = useFadeIn();
  return (
    <div ref={ref} className='JoiningItemsBlock'>
      <h2 className='JoiningItemsBlock__title'>{data.title.value}</h2>

      <Container className={`${fadeClass}`}>
        <div className='JoiningItemsBlock__items'>
          {data.items.expandedValue.map((item: JoiningItemBlockData, i) => {
            return (
              <a key={i} href={item.link.value || null} className='JoiningItemsBlock__items__link'>
                <div className='JoiningItemsBlock__items__link__mask'></div>
                <div {...getBackgroundImageProps(item.image, context)} className='JoiningItemsBlock__items__link__image' />
                <span className='JoiningItemsBlock__items__link__name'>{item.name}</span>
                <span className='JoiningItemsBlock__items__link__button'>&#187;</span>
              </a>
            );
          })}
        </div>
      </Container>
    </div>
  );
};

export default JoiningItemsBlock;
